import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useParks } from "../../Parks/hooks";
import { ImgixImage } from "../../ImgixImage";
import Link from "next/link";
import { useResolveParkPagePath } from "../../Parks";
import { ArrowRight, IconButton, LocationMarkerIcon, Modal, Skeleton, Typography } from "@parkschannel/ui";
export const StickerModal = (param)=>{
    let { isOpen , onClose , parkId  } = param;
    const { useParkQuery  } = useParks();
    const { data  } = useParkQuery(parkId);
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: isOpen,
        setIsOpen: onClose,
        contentClassName: "max-w-6xl",
        children: data ? /*#__PURE__*/ _jsx(StickerModalContent, {
            data: data
        }) : /*#__PURE__*/ _jsx(StickerModalSkeleton, {})
    });
};
function StickerModalContent(param) {
    let { data  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: "lg:flex lg:gap-10 lg:items-center lg:relative lg:items-stretch",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pb-10 mb-10 mt-10 border-b-2 border-b-neutral-100 lg:min-w-[398px] lg:w-[398px] lg:border-b-0 lg:border-r-2 lg:mt-0 lg:mb-0 lg:pb-0 lg:flex lg:items-center lg:self-stretch ",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "relative w-full h-[250px] md:h-[318px]",
                    children: /*#__PURE__*/ _jsx(ImgixImage, {
                        src: data.stickerKey || "",
                        alt: data.name,
                        fill: true,
                        className: "object-contain"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "lg:flex lg:flex-col lg:justify-center ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "lg:grow lg:py-10 ",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h3",
                                className: "text-neutral-900 mb-1",
                                children: data.name
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-start gap-1 w-full mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx(LocationMarkerIcon, {
                                        className: "min-w-[20px] w-5 h-5 mt-[2px]"
                                    }),
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "flex flex-wrap gap-x-2",
                                        children: data.states.map((state, id)=>/*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "captionBase",
                                                    className: "text-neutral-500 inline",
                                                    children: state
                                                })
                                            }, id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "bodyXL",
                                className: "text-neutral-700 mb-10",
                                children: data.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: useResolveParkPagePath(data.slug),
                        className: "lg:absolute lg:bottom-0 lg:right-0",
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            icon: /*#__PURE__*/ _jsx(ArrowRight, {
                                className: "w-5 h-5"
                            }),
                            variant: "base",
                            tabIndex: -1,
                            className: "w-full !drop-shadow text-[14px] flex justify-center",
                            children: "Go to park page"
                        })
                    })
                ]
            })
        ]
    });
}
function StickerModalSkeleton() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "py-6 flex items-center flex-col lg:flex-row lg:gap-10 lg:px-6",
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rounded",
                animation: "animate-shimmer",
                width: "250px",
                height: "250px",
                className: "lg:min-w-[250px]"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col w-full mt-10",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "250px",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100px",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "95%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "50%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "100%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "95%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rounded",
                        animation: "animate-shimmer",
                        width: "50%",
                        height: "15px"
                    })
                ]
            })
        ]
    });
}
